<template>
<div>
  <el-button type="text" @click="dialogVisible = true">修改密码</el-button>
  <el-dialog title="修改密码" :visible.sync="dialogVisible" v-if="dialogVisible" @close="dialogClose" width="40%">
    <el-form :model="password" label-width="100px" ref="form" :rules="pwdForm" class="change-pwd">
      <el-form-item label="当前密码" prop="currentPassword">
        <el-input type="password" v-model="password.currentPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="password.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="verifyPassword">
        <el-input type="password" v-model="password.verifyPassword"></el-input>
      </el-form-item>
      <el-form-item class="pwd-operation">
        <el-button type="primary" @click="onSubmit">修改密码</el-button>
        <el-button type="primary" @click="onReturn">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
import { changePassword } from '@/api/auth-controller'

// TODO: add validatePassword Method
// import { validatePassword } from '@/utils/validate';

export default {
  name: 'changePassword',
  data () {
    var validateNewPwd = (rule, value, callback) => {
      // const intensity4 = /^[0-9]{1,20}$/
      if (value) {
        // if (intensity4.test(value)) {
        //   callback(new Error('纯数字密码过于简单，请重新输入'))
        // }
        if (this.password.verifyPassword !== '') {
          this.$refs.form.validateField('verifyPassword')
        }
        callback()
      } else {
        callback(new Error('请输入新密码'))
      }
    }
    var validateVerifyPwd = (rule, value, callback) => {
      if (value !== this.password.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      password: {
        currentPassword: '',
        newPassword: '',
        verifyPassword: ''
      },
      pwdForm: {
        currentPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validateNewPwd, trigger: 'blur' },
          { min: 8, max: 20, message: '密码不能小于8位，大于20位', trigger: 'blur' }
        ],
        verifyPassword: [
          { required: true, message: '请输入再次新密码', trigger: 'blur' },
          { validator: validateVerifyPwd, trigger: 'blur' },
          { min: 8, max: 20, message: '密码不能小于8位，大于20位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.password.currentPassword === this.password.newPassword) {
            this.$message.error('新密码与原密码一致，请重新输入')
            return false
          }
          changePassword(this.password.currentPassword, this.password.newPassword).then((res) => {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.dialogClose()
          }).catch(err => {
            this.$message.error('密码不匹配，请输入正确的原密码')
            console.log(err)
          })
        } else {
          this.$message.error('请按提示输入信息')
          return false
        }
      })
    },
    onReturn () {
      this.dialogVisible = false
      this.password.currentPassword = ''
      this.password.newPassword = ''
      this.password.verifyPassword = ''
    },
    dialogClose () {
      this.password.currentPassword = ''
      this.password.newPassword = ''
      this.password.verifyPassword = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.change-pwd {
  .el-form-item{
    margin-bottom: 20px;
  }
  .pwd-operation {
    margin: 10px 0;
  }
}
//  FIXME: element margin bug
</style>
